<template>
    <div class="outsid">
        <div class="bread">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item style="cursor: pointer;" @click.native="handleBack">导师陪跑</el-breadcrumb-item>
                <el-breadcrumb-item>{{ info.name }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="detaiCon">
            <div class="topPart flx alc jsb">
                <div class="topLeft">
                    <div class="topNames flx alc">
                        <div class="coachName" v-text="info.name"></div>
                        <img v-if="info.follow_status === 0" class="coachFcs"
                            :src="$Localimg('coachFocus.png')" alt="关注" @click="focusT" />
                        <img v-else-if="info.follow_status === 1" class="coachFcs"
                            :src="$Localimg('ncoachFocus.png')" alt="已关注" @click="focusT" />
                    </div>
                    <div class="coachdes" v-text="info.title"></div>
                    <div class="labels flx alc">
                        <div class="label" v-for="(item, index) in labels" :key="index" v-text="item.name"></div>
                    </div>
                    <div class="goodsAt">擅长领域：{{ info.good_at }}</div>
                    <div class="goodsAt">常住地：{{ info.city_name }}</div>
                    <div class="askbtn" v-if="info.join_status === 0" @click="ask">免费加入“弟子班”</div>
                    <div class="askbtn disabled" v-else>已经加入“弟子班”</div>
                </div>
                <div class="topRight">
                    <img :src="$img(info.transparent_avatar)" alt="导师头像" />
                </div>
            </div>
            <div class="bottomItem">
                <div class="coachTitle">
                    <div class="titleName">《导师陪跑》栏目介绍</div>
                    <div class="linearheng1"></div>
                </div>
                <div class="coachDess textDess" v-text="contentt"></div>
            </div>
            <div class="flx" style="margin-top: 20px;">
                <div class="bottomItem">
                    <div class="coachTitle">
                        <div class="titleName">导师介绍</div>
                        <div class="linearheng"></div>
                    </div>
                    <!-- 富文本：图片块级化 + 段落去 margin，解决图片上下空白 -->
                    <div class="coachDess richDess" v-html="info.intro"></div>
                </div>
                <div class="tipRight" style="margin-left: 16px;" v-if="info.recomm_mentor_list.length">
                    <div class="bottomPart">
                        <div class="bpt">推荐导师</div>
                        <div class="reItem cursor"
                            v-for="(item, index) in info.recomm_mentor_list"
                            :key="item.id || index"
                            :style="index === info.recomm_mentor_list.length - 1 ? { border: 'none', marginBottom: 0 } : {}"
                            @click="toDetail(item)">
                            <div class="reImg">
                                <img :src="$img(item.recom_avatar)" alt="" />
                            </div>
                            <div class="reInfo">
                                <div class="reName multy2" v-text="item.name"></div>
                                <div class="reTitle single" v-text="item.title"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    getCoachDetail,
    focusTeacher,
    getConfig,
    subcoachs,
    userInfo
} from "@/api/index.js"
import YSF from '@neysf/qiyu-web-sdk';

export default {
    name: "index",
    data() {
        return {
            id: "",
            info: {
                recomm_mentor_list: []   // 默认空数组，避免模板中 .length 报错
            },
            labels: [],
            contentt: ""
        };
    },
    created() {
        this.id = this.$route.query.id
        this.getDetail()
    },
    watch: {
        '$route.query.id'(id) {
            if (id === this.id) return
            this.id = id
            this.getDetail()
        }
    },
    methods: {
        getDetail() {
            const id = this.id
            getConfig().then((res) => {
                if (res.code === 1) {
                    this.contentt = res.data.mentro_intro
                }
            })
            getCoachDetail(id).then((res) => {
                if (res.code === 1) {
                    this.info = res.data
                    this.labels = this.parseLabels(res.data.label)
                    this.$nextTick(() => {
                        window.scrollTo(0, 0)
                    })
                }
            })
        },
        // label 可能是 JSON 字符串或数组，统一容错解析
        parseLabels(label) {
            if (!label) return []
            if (Array.isArray(label)) return label
            try {
                return JSON.parse(label) || []
            } catch (e) {
                return []
            }
        },
        focusT() {
            const data = { id: this.id }
            focusTeacher(data).then((res) => {
                if (res.code === 1) {
                    this.$message.success(res.msg)
                    this.getDetail()
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        toDetail(e) {
            this.$router.push({
                path: '/coachDetail',
                query: {
                    id: e.id
                }
            })
        },
        ask() {
            userInfo().then((res) => {
                if (res.code === 1) {
                    const data = { mentor_id: this.id }
                    subcoachs(data).then((Res) => {
                        if (Res.code === 1) {
                            this.$router.push({
                                path: '/joinsuccess'
                            })
                        } else {
                            this.$message.error(Res.msg)
                        }
                    })
                }
            })
            // 如需接入七鱼客服，可取消注释
            // ysf('open')
            // ysf('sendProduct', {
            //     sendProToRobot: 1,
            //     title: this.info.name,
            //     desc: '导师陪跑',
            //     avatar: this.$img(this.info.transparent_avatar),
            //     sendByUser: 1,
            //     success: () => {},
            //     error: (err) => {}
            // }, 6000)
        },
        handleBack() {
            this.$router.push('/coach')
        }
    }
};
</script>

<style scoped>
/* ============ 通用布局 ============ */
.outsid {
    width: 100%;
    min-height: 820px;
    background: url('https://two.hrxsl.com/pcImages/teacherbk.png') no-repeat;
    background-size: 100% auto;
}

.detaiCon {
    width: 1460px;
    margin: 0 auto;
}

.bottomItem {
    flex: 1;
    box-sizing: border-box;
    padding: 26px;
    border-radius: 10px;
    background: #fff;
}

/* ============ 顶部导师信息 ============ */
.topPart {
    box-sizing: border-box;
    padding: 46px 54px 0 109px;
}

.coachName {
    margin-right: 27px;
    font-size: 30px;
    font-weight: 600;
    color: #000;
}

.coachFcs {
    height: 40px;
    object-fit: contain;
    position: relative;
    top: 5px;
    cursor: pointer;
}

.coachdes {
    margin-top: 22px;
    font-size: 20px;
    font-weight: 500;
    color: #7F3F0F;
    text-align: left;
}

.labels {
    margin-top: 22px;
}

.label {
    margin-right: 10px;
    padding: 2px 6px;
    border-radius: 4px;
    background: #fff;
    font-size: 16px;
    color: #4895FB;
}

.goodsAt {
    margin-top: 18px;
    font-size: 18px;
    font-weight: 600;
    color: #53586C;
    text-align: left;
}

.askbtn {
    width: 280px;
    height: 34px;
    margin-top: 20px;
    border-radius: 17px;
    background: #007AFF;
    font-size: 14px;
    line-height: 34px;
    text-align: center;
    color: #fff;
    cursor: pointer;
}

.askbtn.disabled {
    background: #e0e0e0 !important;
    cursor: default;
}

.topRight {
    width: 274px;
    height: 338px;
}

.topRight img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

/* ============ 栏目标题 ============ */
.coachTitle {
    position: relative;
    margin-bottom: 20px;
}

.titleName {
    position: relative;
    z-index: 3;
    font-size: 18px;
    font-weight: 600;
    color: #222222;
    text-align: left;
}

.linearheng,
.linearheng1 {
    position: absolute;
    bottom: 0;
    width: 72px;
    height: 8px;
    background: linear-gradient(90deg, #BAD9FF 0%, rgba(255, 255, 255, 0) 100%);
}

.linearheng {
    left: 0;
}

.linearheng1 {
    left: 10px;
}

/* ============ 正文 / 富文本 ============ */
.coachDess {
    text-align: left;
    line-height: 1.6;
    word-break: break-word;
}

/* 纯文本介绍保留换行 */
.coachDess.textDess {
    white-space: pre-wrap;
}

/* 核心修复：富文本图片块级化，消除行内基线导致的上下空白 */
.coachDess.richDess /deep/ img {
    display: block;
    width: 100%;
    height: auto;
    margin: 0;
}

/* 富文本段落去掉默认 margin，图片不再被 p 间距撑出空白 */
.coachDess.richDess /deep/ p {
    margin: 0;
}

/* 段落之间保留少量间距，排版不粘连 */
.coachDess.richDess /deep/ p + p {
    margin-top: 12px;
}

/* ============ 推荐导师 ============ */
.tipRight {
    border-radius: 10px;
    overflow: hidden;
}

.bottomPart {
    width: 365px;
    box-sizing: border-box;
    padding: 20px;
    background: #fff;
}

.bpt {
    margin-bottom: 20px;
    font-size: 24px;
    font-weight: 600;
    text-align: left;
}

.reItem {
    width: 100%;
    margin-bottom: 20px;
    border-bottom: 1px solid #ececec;
}

.reImg {
    width: 292px;
    height: 164px;
}

.reImg img {
    width: 100% !important;
    height: 100%;
    border-radius: 6px;
    object-fit: scale-down;
}

.reInfo {
    box-sizing: border-box;
    padding: 12px 12px 20px;
    text-align: left;
}

.reName {
    margin-bottom: 14px;
    font-size: 16px;
    font-weight: 600;
}

.reTitle {
    font-size: 14px;
    color: #919296;
}
</style>
